import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CollapseComponent } from '../../collapse/collapse.component';
import { ProcessDescription } from '../process';

@Component({
  selector: 'smw-process-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.less'],
  imports: [CollapseComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionComponent {
  resource = input.required<ProcessDescription>();

  title = computed(() => this.resource().title);
  content = computed(() => this.resource().content);
}
